
const radio = {
  sizes: {
    md: {
      control: { },
      label: { fontSize: '12px' },
    }
  }
};

export default radio;